import { queryDoctorList, querySeoDoctorList } from "api/hospital";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { onClickhref, toFixed, getMinValueFromArray } from "utils";
import fillJsfImage from "utils/fillJsfImages";
import { getPageId, setHospitalTDK } from "utils/hospital";
import Blank from "../components/blank";
import Pagination from "../components/pagination";
import Template from "../components/template";
import DepartTemplate from "../departPage/departTemplate";
import styles from '../index.less';
const reg = /\d+/g;

function useParamsForHospitalAndDepartment() {
  let params = useParams<Record<any, any>>();
  console.log("params1", params);
  if (params.did) {
    const _params = { ...params };
    if (params.hid?.indexOf("-") > -1) {
      const hidarr = params.hid?.split("-");
      _params.hid = hidarr?.[0];
      _params.did = hidarr?.[1];
      _params.current = params.did;
      params = _params;
    }
  }
  console.log("params2", params);
  let { pageId: id, current } = getPageId(params.id || params.did);
  const departId = params.did ? id : undefined;
  const pageId = params.hid || id;
  if (params.current !== undefined) {
    current = params.current;
  }

  const info = {
    params,
    pageId,
    departId,
    current,
    id,
  };

  console.log("params3", info);
  return info;
}

// 医生主页
const DoctorList = () => {

  const paramsInfo = useParamsForHospitalAndDepartment();
  const { params, pageId, departId, current: pageNo, id } = paramsInfo;
  
  const [data, setData] = useState<any>([]);
  const [current, setCurrent] = useState<any>(pageNo);
  const [nextPage, setNextPage] = useState<any>(false);
  useEffect(() => {
    setCurrent(pageNo);
    getDoctorList(pageId, +current);
  }, []);
  // 获取医生列表
  const getDoctorList = (hospitalId: any, pageIndex: number) => {
    const func = departId ? querySeoDoctorList : queryDoctorList;
    const param: any = {
      channel: 1,
      pageIndex,
      pageSize: 10,
      keyWords:{
        hospitalId,
        secondDepartmentId: departId
      },
    }
    if (departId) {
      param.keyWords.businessSource = 'seo';
    }
    func(param).then((res: any) => {
      setData(res.doctorList || []);
      setCurrent(res.pageIndex);
      setNextPage(res.hasNextPage);
    })
  }
  const TabTemplate = departId ? DepartTemplate : Template;
  // 掉楼逻辑（与分页冲突，暂时注释）
  // if (!data?.length) {
  //   return null;
  // }
  return (
    <TabTemplate breadTitle={departId ? "科室医生" : "推荐医生"}>
      {
        (hospitalInfo?: any, departInfo?: any) => {
          let avtiveName = hospitalInfo?.hospitalName;
          if (departInfo) {
            // 设置TDK
            avtiveName = `${avtiveName}${departInfo?.departName}`;
          }
          setHospitalTDK(
            `${avtiveName}哪个医生好/推荐专家 - 京东健康互联网医院`,
            `${avtiveName}哪个医生好,${avtiveName}推荐专家`,
            `${avtiveName}哪个医生好,京东健康互联网医院提供${avtiveName}推荐专家,可以查询${avtiveName}医生的简介、专业擅长、出诊时间等信息,帮你找对医生看对病`
          );
          return (
            <Blank className={styles.doctorList} title={`${departInfo?.departName || ''}推荐医生`}>
              <div className={styles.doctorcontent}>
                {
                  data?.length > 0 ? data?.map(({ doctorInfo, hospitalInfo, feedbackInfo, doctorId, goodAtInfo, priceDiscountsVolunteerDiag, doctorServiceInfo, extendInfo }: any, index: number) => {
                    return <div className={styles.doctors} key={doctorId} onClick={() => onClickhref(`/doctor/${doctorId}`)}>
                      <div className={styles.avtor}>
                        <img src={fillJsfImage(doctorInfo.doctorHeadPic)} alt={doctorInfo.doctorName} />
                      </div>
                      {/* 医生详细信息 */}
                      <div className={styles.doctorDetail}>
                        {/* 顶部 */}
                        <div className={styles.detailTop}>
                          <div className={styles.detailTopLeft}>
                            <div className={styles.detailDoctorName}>
                              {/* 三甲 */}
                              {doctorInfo.secondTagList &&
                                doctorInfo.secondTagList.map((item: any, i: any) => <label key={i}>{item.tagContent}</label>
                              )}
                              {/* 是否可开方 */}
                              {
                                doctorInfo?.firstTagList &&
                                doctorInfo?.firstTagList.map((item: any, i: any) => (
                                  <span key={i}>
                                    {item.tagField == 'openRx' && <label>{item.tagContent}</label>}
                                    {item.tagField == 'notOpenRx' && <label>{item.tagContent}</label>}
                                  </span>
                                ))
                              }
                              <span className={styles.docName} data-a-href={`/doctor/${doctorId}`}>{doctorInfo?.doctorName}</span>
                              <span>{doctorInfo?.doctorTitleName}</span>
                            </div>
                            <div className={styles.detailDoctorName}>
                              <span>{hospitalInfo?.hospitalName}</span>
                              <span>{hospitalInfo?.secondDepartName}</span>
                            </div>
                          </div>
                          <div className={styles.detailTopRight}>
                            <span>
                              立即咨询
                            </span>
                          </div>
                        </div>
                        <div className={styles.detailMiddle}>
                          <div className={styles.evaluateGoods}>好评率：<span>{feedbackInfo?.patientEvaluationRate}</span></div>
                          <span />
                          <div className={styles.people}>接诊人数：<span>{feedbackInfo?.receivePatientNum}</span></div>
                          <span />
                          <div className={styles.people}>平均等待时长：<span>{feedbackInfo?.averageResponseTime}</span></div>
                        </div>
                        <div className={styles.detailGoodAt}>
                          擅长: {goodAtInfo?.doctorGoodAt}{' '}
                        </div>
                        <div className={styles.detailPrice}>
                          <div className={styles.price}>
                            <span>
                              <b>¥</b>{getMinValueFromArray(extendInfo?.showServiceInfo, 'currentPrice')}
                            </span>起
                          </div>
                          <div className={styles.serviceType}>
                            {
                              doctorServiceInfo &&
                              doctorServiceInfo?.doctorServiceInfoList &&
                              doctorServiceInfo?.doctorServiceInfoList?.map((item: any) => item)?.join('、')
                            }
                          </div>
                        </div>
                        <div className={styles.divider} />
                      </div>
                    </div>
                  }) : <div className={styles.noData}>暂无科室医生</div>
                }
              </div>
              {data?.length > 0 && <Pagination
                  pageId={pageId}
                  current={current}
                  nextPage={nextPage}
                  nextUrl={`/hospital${departId ? `/department` : ''}/${pageId}${departId ? `-${departId}` : ''}-${current+1}/yishenglist`}
                  preUrl={`/hospital${departId ? `/department` : ''}/${pageId}${departId ? `-${departId}` : ''}-${current-1}/yishenglist`}
                />}
            </Blank>
          )
        }
      }
    </TabTemplate>
  );
};

export default DoctorList;